import { Outlet } from 'react-router-dom'
import { AccessDeniedOverlay } from '@/components/auth/AccessDeniedOverlay'

export function RootLayout() {
  return (
    <div className="min-h-screen bg-white dark:bg-[#020617]">
      <Outlet />
      {/* Phase 1 RBAC §1.2: global 403 handler — backend remains the boundary. */}
      <AccessDeniedOverlay />
    </div>
  )
}
